import { createContext } from 'react';

import type { Form } from 'types';

type FormsListContextType = {
  data: any;
  isError: boolean;
  isLoading: boolean;
  massActionsSelectedForms: Form[];
  allFormsMassActionsSelected: boolean;
  newFormWizardOpen: boolean;
  isFormMassActionsSelected: (id: number) => boolean;
  toggleFormMassActionsSelected: (form: Form) => void;
  toggleAllMassActionsSelected: () => void;
  setNewFormWizardOpen: (open: boolean) => void;
};

export const FormsListContext = createContext<FormsListContextType | null>(
  null,
);
